import { __read } from "tslib";
export var noStartingOrEndingSlash = function (value) {
    var _a = __read(value, 1), firstChar = _a[0];
    var lastChar = value.slice(-1);
    return firstChar !== '/' && lastChar !== '/';
};
//# sourceMappingURL=no-starting-or-ending-slash-validator.js.map